import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { UseQueryOptions, useQuery } from 'react-query'
import { BrandKitAvatar } from 'types'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

interface ListData {
  avatars: BrandKitAvatar[]
}

export const brandKitAvatarsCacheKey = (workspaceId: number, brandKitId?: number) =>
  ['workspaces', workspaceId, 'brandKits', brandKitId, 'avatars', 'list'] as const

export const fetchBrandKitAvatars = async (workspaceId: number, brandKitId: number) => {
  const res = await sendToApi<ListData>(`/w/${workspaceId}/brand_kits/${brandKitId}/avatars`)
  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error('Failed to fetch avatars')
  }
  return res.data
}

export const useBrandKitAvatars = (
  { brandKitId }: { brandKitId?: number },
  options?: UseQueryOptions<BrandKitAvatar[]>,
) => {
  const workspaceId = useCurrentWorkspaceId()

  return useQuery<BrandKitAvatar[]>(
    brandKitAvatarsCacheKey(workspaceId, brandKitId),
    async () => {
      if (!brandKitId) throw new Error('brandKitId is required')
      const data = await fetchBrandKitAvatars(workspaceId, brandKitId)
      return data?.avatars ?? []
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!brandKitId,
      ...options,
    },
  )
}
